import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

import { Spirit } from '../styles/spirit-styles'
import { Layout } from '../components/common/layout'
import { APICard } from '../components/api'
import { MetaData, getMetaImageUrls } from '../components/common/meta'

const APIPage = ({ data, location }) => {
    // Add meta title and description or this page here to overwrite the site meta data as set in the config
    const title = `Common Resources`
    const description = `Collections of useful links and demo app via Appstore or Google Play store`
    const imageUrl = getMetaImageUrls()

    const sectionStyles = {
        headingContainer: `col-12 col-4-ns mr10-ns`,
        cardContainer: `col-12 col-8-ns mt-vw4 mt0-ns grid-icon-boxes`,
    }

    return (
        <>
            <MetaData
                data={data}
                location={location}
                type="website"
                title={title}
                description={description}
                image={imageUrl}
            />
            <Layout mainClass="bg-whitegrey-l2" bodyClass="bg-white">
                <section className="bg-api-reference">
                    <div className={`${Spirit.page.xl} tc-ns pt-vw6 pt-vw5-ns pb-vw5 white`}>
                        <h1 className={`${Spirit.sectionHeading} gh-integration-header-shadow`}>Common Resources</h1>
                        <p className={Spirit.sectionSubHeading}>Collections of useful links and resource form InspireUI</p>
                    </div>
                </section>

                <div className={`${Spirit.page.l} pb-vw4 pb-vw3-ns pt-vw4 pt-vw3-ns`}>
                    <div className="grid-12">
                        <div className={sectionStyles.headingContainer}>
                            <h2 id="frontend-sdk" className={`${Spirit.h3} pt20 nt20`}>Flutter Builder</h2>
                            <p className={`${Spirit.small} midgrey-l2 mt2`}>An Ultimate Approach For Flutter Apps</p>
                        </div>
                        <div className={sectionStyles.cardContainer}>
                            <APICard href="https://apps.apple.com/us/app/fluxbuilder-pro/id1503282735" icon="ic-ios2">iOS</APICard>
                            <APICard href="https://play.google.com/store/apps/details?id=com.inspireui.fluxbuilderpro&hl=en" icon="ic-android2">Android</APICard>
                            <APICard href="https://apps.apple.com/vn/app/fluxbuilder/id1500753204?mt=12" icon="laptop">MacOS</APICard>
                            <APICard href="https://github.com/inspireui/fluxbuilder/releases/download/latest/FluxBuilder_windowOS.zip" icon="window-pulse">WindowOS</APICard>
                            {/* <APICard to="/api/gatsby/" icon="gatsby-logo">Gatsby</APICard> */}
                        </div>
                    </div>

                    <div className="grid-12 mt-vw4 mt20-ns">
                        <div className={sectionStyles.headingContainer}>
                            <h2 id="frontend-sdk" className={`${Spirit.h3} pt20 nt20`}>Reference</h2>
                            <p className={`${Spirit.small} midgrey-l2 mt2`}>Common useful links you may like to explore from our product</p>
                        </div>
                        <div className={sectionStyles.cardContainer}>
                            <APICard href="https://www.youtube.com/inspireui?sub_confirmation=1" icon="ic-youtube">Youtube</APICard>
                            <APICard href="https://support.inspireui.com" icon="ic-git">Ticket Support</APICard>
                            {/* <APICard to="/api/gatsby/" icon="gatsby-logo">Gatsby</APICard> */}
                        </div>
                    </div>

                    <div className="grid-12 mt-vw4 mt20-ns">
                        <div className={sectionStyles.headingContainer}>
                            <h2 id="rest-api" className={`${Spirit.h3} pt20 nt20`}>Demo</h2>
                            <p className={`${Spirit.small} midgrey-l2 mt2`}>Resource link for the demo app</p>
                        </div>
                        <div className={sectionStyles.cardContainer}>
                            <APICard href="https://itunes.apple.com/br/developer/inspireui-company-limited/id1192736196?l=en" icon="ic-ios2">AppStore</APICard>
                            <APICard href="https://play.google.com/store/apps/developer?id=InspireUI" icon="ic-android2">Google Play</APICard>
                        </div>
                    </div>

                    <div className="grid-12 mt-vw4 mt20-ns">
                        <div className={sectionStyles.headingContainer}>
                            <h2 id="rest-api" className={`${Spirit.h3} pt20 nt20`}>Products</h2>
                            <p className={`${Spirit.small} midgrey-l2 mt2`}>Explore more detail info from the product</p>
                        </div>

                        <div className={sectionStyles.cardContainer}>
                            <APICard href="https://inspireui.com/about" icon="ic-web">inspireui.com</APICard>
                            <APICard href="https://fluxbuilder.com" icon="ic-web">fluxbuilder.com</APICard>
                            <APICard href="https://fluxstore.app" icon="ic-web">fluxstore.app</APICard>
                            <APICard href="https://mstore.io" icon="ic-web">mstore.io</APICard>
                        </div>
                    </div>




                    {/* <div className="grid-12 mt-vw4 mt20-ns">
                        <div className={sectionStyles.headingContainer}>
                            <h2 id="client-libraries" className={`${Spirit.h3} pt20 nt18`}>Client Libraries</h2>
                            <p className={`${Spirit.small} midgrey-l2 mt2`}>Specific libraries for interacting with the Ghost API directly</p>
                            <h4 className="f-supersmall dib ma0 pa0 bg-green pa1 br-pill pl3 pr3 tc white mt2 nudge-top--2">Coming soon</h4>
                        </div>
                        <div className={sectionStyles.cardContainer}>
                            <APICard to="/api/javascript/" icon="javascript-logo">JavaScript</APICard>
                            <APICard icon="ruby-logo" iconClass="stroke-midlightgrey o-30">Ruby</APICard>
                            <APICard icon="php-logo" iconClass="stroke-midlightgrey o-30">PHP</APICard>
                            <APICard icon="python-logo" iconClass="stroke-midlightgrey o-30">Python</APICard>
                            <APICard icon="apple-logo" iconClass="stroke-midlightgrey o-30">iOS</APICard>
                            <APICard icon="android-logo" iconClass="stroke-midlightgrey o-30">Android</APICard>
                        </div>
                    </div> */}
                </div>
            </Layout>
        </>
    )
}

APIPage.propTypes = {
    data: PropTypes.shape({
        site: PropTypes.shape({
            siteMetadata: PropTypes.shape({
                siteUrl: PropTypes.string.isRequired,
                title: PropTypes.string.isRequired,
                description: PropTypes.string.isRequired,
            }).isRequired,
        }).isRequired,
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
}

export default APIPage

export const pageQuery = graphql`
    query {
        site {
            ...SiteMetaFields
        }
    }
`
